import CaseTaskBadgeForCase from "@/components/Table/MrtCaseFilters/CaseTaskBadgeForCase.tsx";
import NotificationBadgeForCase from "@/components/Table/MrtCaseFilters/NotificationBadgeForCase.tsx";
import type { MrtDashboardCase } from "@/queries/useFetchMrtDashboardCases.ts";
import { dateFormatterDashed } from "@/utils/mapDateOrStringToLocalDate.ts";
import { ChronoUnit, LocalDate } from "@js-joda/core";
import { Box } from "@mui/material";
import type { MRT_ColumnDef } from "material-react-table";

const caseColumnDefs: MRT_ColumnDef<MrtDashboardCase>[] = [
    {
        accessorKey: "id",
        header: "Case #",
    },
    {
        accessorKey: "clientName",
        header: "Client Name",
    },
    {
        accessorKey: "caseType",
        header: "Type",
    },
    {
        accessorKey: "caseStatus",
        header: "Liability Status",
    },
    {
        accessorKey: "caseStatusUM",
        header: "UM Status",
    },
    {
        accessorKey: "caseName",
        header: "Important Notes",
    },
    {
        accessorKey: "dateOfIncident",
        header: "DOI",
        Cell: ({ renderedCellValue }) => {
            if (renderedCellValue instanceof LocalDate) {
                return renderedCellValue.format(dateFormatterDashed);
            }

            return "";
        },
    },
    {
        accessorKey: "solDays",
        header: "SOL Days",
        Cell: ({ row }) => {
            if (row.original.statuteOfLimitations) {
                const today = LocalDate.now();
                return ChronoUnit.DAYS.between(today, row.original.statuteOfLimitations);
            }

            return "";
        },
    },
    {
        accessorKey: "lastTouch",
        header: "DSC",
        Cell: ({ row }) => {
            if (row.original.lastTouch) {
                const today = new Date();
                return Math.floor(
                    (today.getTime() - row.original.lastTouch.getTime()) / (1000 * 60 * 60 * 24),
                );
            }

            return "";
        },
    },
    {
        accessorKey: "assignedToParalegalPretty",
        header: "Case Manager",
    },
    {
        accessorKey: "assignedTeam",
        header: "Team",
    },
    {
        accessorKey: "assignedToAttorneyPretty",
        header: "Attorney",
    },
    {
        accessorKey: "alerts",
        header: "Alerts",
        Cell: ({ row }) => {
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <NotificationBadgeForCase caseUUID={row.original.idUUID} />
                    <CaseTaskBadgeForCase caseUUID={row.original.idUUID} />
                </Box>
            );
        },
        size: 90,
    },
];

export default caseColumnDefs;
